<template>
  <span>
    <button @click="toggleVisibility" class="btn btn-secondary"><small>{{ $t('components.credits.buttons.credits') }}</small></button>
    <div class="overlay" @click="toggleVisibility" v-if="isVisible">
      <div class="content-wrapper">
        <button class="btn btn-link"><span class="material-icons">close</span></button>
        <div class="content shadow">
          <table>
            <tr>
              <td>
                <a href="https://pixabay.com/de/users/ryanmcguire-123690/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=413685">
                  <div class="image-ref" id="ryanmcguire-123690">
                    <div class="credit-overlay">
                      <div class="credit-content"></div>
                    </div>
                  </div>
                </a>
              </td>
              <td>
                <i>Hintergrundbild &bdquo;Datenschutz- und Cookie-Hinweis&ldquo;</i><br />
                Bild von <a href="https://pixabay.com/de/users/ryanmcguire-123690/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=413685">Ryan McGuire</a> auf <a href="https://pixabay.com/de/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=413685">Pixabay</a>
              </td>
            </tr>
            <tr>
              <td>
                <a href="https://www.toptal.com/designers/subtlepatterns/bananas/">
                  <div class="image-ref" id="bananas-marievandenbroeck">
                    <div class="credit-overlay">
                      <div class="credit-content"></div>
                    </div>
                  </div>
                </a>
              </td>
              <td>
                <i>Alternatives Hintergrundmuster</i><br />
                &bdquo;This pattern is bananas, b-a-n-a-n-a-s!&ldquo; made by <a href="https://www.toptal.com/designers/subtlepatterns/bananas/">Marie Van den Broeck</a>
              </td>
            </tr>
            <tr>
              <td>
                <a href="https://www.toptal.com/designers/subtlepatterns/funky-lines/">
                  <div class="image-ref" id="funkylines-shiva">
                    <div class="credit-overlay">
                      <div class="credit-content"></div>
                    </div>
                  </div>
                </a>
              </td>
              <td>
                <i>Alternatives Hintergrundmuster</i><br />
                &bdquo;Just like the title says-some funky diagonal lines.!&ldquo; made by <a href="https://www.toptal.com/designers/subtlepatterns/funky-lines/">Shiva</a>
              </td>
            </tr>
            <tr>
              <td>
                <a href="https://www.toptal.com/designers/subtlepatterns/transparent-square-tiles/">
                  <div class="image-ref" id="squares-nathan">
                    <div class="credit-overlay">
                      <div class="credit-content"></div>
                    </div>
                  </div>
                </a>
              </td>
              <td>
                <i>Alternatives Hintergrundmuster</i><br />
                &bdquo;Transparent Square Tiles&ldquo; made by <a href="https://www.toptal.com/designers/subtlepatterns/transparent-square-tiles/">Nathan Spady</a>
              </td>
            </tr>
            <tr>
              <td>
                <a href="https://undraw.co/">
                  <div class="image-ref" id="undraw">
                    <div class="credit-overlay">
                      <div class="credit-content"></div>
                    </div>
                  </div>
                </a>
              </td>
              <td>
                <i>Titelbild Profilausdruck</i><br />
                &bdquo;Proud Developer&ldquo; created by <a href="https://undraw.co/">undraw.co</a>
              </td>
            </tr>
            <tr>
              <td>
                <a href="https://www.iconfinder.com/vectto">
                  <div class="image-ref" id="iconfinder-minions">
                    <div class="credit-overlay">
                      <div class="credit-content"></div>
                    </div>
                  </div>
                </a>
              </td>
              <td>
                <i>Icon &bdquo;Minion&ldquo;</i><br />
                <div>Icon created by <a href="https://www.iconfinder.com/vectto">vectto</a></div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
  export default {
    name: "Credits",
    data() {
      return {
        isVisible: false
      }
    },
    methods: {
      toggleVisibility: function() { this.isVisible = !this.isVisible }
    }
  }
</script>

<style scoped lang="scss">
  div#ryanmcguire-123690 { background-image: url('../assets/img/components/data-privacy-banner/background-data-privacy-cookies.jpg');}
  div#bananas-marievandenbroeck { background-image: url('../assets/img/background/bananas.png');  background-size: auto; background-repeat: repeat; }
  div#funkylines-shiva { background-image: url('../assets/img/background/funky-lines.png'); background-size: auto; background-repeat: repeat; }
  div#squares-nathan { background-image: url('../assets/img/background/squares.png'); background-size: auto; background-repeat: repeat; }
  div#undraw { background-image: url('../assets/img/personal/cover-image-proud.svg');  }
  div#iconfinder-minions { background-image: url('../assets/img/icons/minion.svg'); background-size: auto; }

  div.image-ref {
    margin-right: 1em;
    background-size: cover;
    height: 100px;
    width: 100px;
    display: block;
    position: relative;
    display: inline-block;
    .credit-overlay {
      background: rgba(255,255,255,0.3);
      height: 100px;
      width: 100px;
      position: relative;
      &:hover {
        background: rgba(255,255,255,0.0);
      }
      .credit-content {
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
      }
    }
  }

  .overlay {
    position: fixed;
    overflow-y: scroll;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.95);
    z-index: 100;
    opacity: 1;
    visibility: visible;
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
    .content-wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      .content {
        background: #ffffff;
        padding: 1rem;
      }
    }
  }
</style>
